import { EstimationPresets } from '../App';

export const INDUSTRY_IDS = [
  'Accountant',
  'Architect',
  'Café',
  'Consultants',
  'E-Commerce',
  'Hairdresser',
  'Health clinics',
  'Home office',
  'IT services',
  'Lawyers',
  'Professional services',
  'Motels',
  'Real estate agent',
  'Restaurants',
  'Retail',
  'Surveyor',
  'Yachting / Boating',
] as const;

type LabelsType = { [key in IndustryIdType]: string };

const INDUSTRY_LABELS: LabelsType = {
  Accountant: 'Accountants',
  Architect: 'Architects',
  Café: 'Cafés',
  Consultants: 'Consultants',
  'E-Commerce': 'E-Commerce',
  Hairdresser: 'Hairdressers',
  'Health clinics': 'Health clinics',
  'Home office': 'Home offices',
  'IT services': 'IT services',
  Lawyers: 'Lawyers',
  'Professional services': 'Professional services',
  Motels: 'Motels',
  'Real estate agent': 'Real estate agents',
  Restaurants: 'Restaurants',
  Retail: 'Retail',
  Surveyor: 'Surveyors',
  'Yachting / Boating': 'Yachting / Boating',
};
export type IndustryIdType = typeof INDUSTRY_IDS[number];
export type IndustryEmittorType = {
  [key in IndustryIdType]: { label: string; unit: string };
};

export type MerchantConfig = {
  styles: {
    colorPrimary: string;
    colorSecondary: string;
    colorButtonTextPrimary: string;
    colorButtonTextSecondary: string;
    pageBackground: string;
  };
  estimationPresets: EstimationPresets;
  title: string;
};

export const getIndustryLabelById = (industryId: IndustryIdType): string => {
  const label = INDUSTRY_LABELS[industryId];
  if (!label)
    throw Error(
      `${industryId} does not have a label. Most likely the id isn't valid.`,
    );
  return label;
};

export const getMerchantConfig = (merchantCode: string): MerchantConfig => {
  if (configs[merchantCode]) return configs[merchantCode];

  console.log(`Could not find: ${merchantCode}. Use default`);
  return defaultConfig;
};

//@ts-ignore
const defaultEmittorLabels: IndustryEmittorType = INDUSTRY_IDS.reduce(
  (object, industryId) => {
    const labels =
      industryId === 'Yachting / Boating'
        ? {
            label: 'Expected annual consumption, Liters',
            unit: 'liters of fuel consumption per year',
          }
        : { label: 'Number of employees', unit: 'employees' };
    return (
      //@ts-ignore
      (object[industryId] = labels), object
    );
  },
  {},
);

const defaultConfig: MerchantConfig = {
  styles: {
    colorPrimary: '#2AA43C',
    colorSecondary: '#228330',
    colorButtonTextPrimary: '#FFFFFF',
    colorButtonTextSecondary: '#FFFFFF',
    pageBackground: '#F4FBF5',
  },
  estimationPresets: {
    industryIds: [...INDUSTRY_IDS],
    industryId: 'Accountant',
    emittorLabels: defaultEmittorLabels,
    country: 'NZ',
    region: 'DEFAULT',
  },
  title: 'Estimate your emissions',
};

const configs: Record<string, MerchantConfig> = {
  AA_FUEL: {
    ...defaultConfig,
    styles: { ...defaultConfig.styles, colorPrimary: '#FFD400' },
    estimationPresets: {
      ...defaultConfig.estimationPresets,
      industryId: 'Consultants',
    },
  },
  MYC_PW_SAPPHIRE_TRAVELLER: {
    ...defaultConfig,
    styles: {
      ...defaultConfig.styles,
      colorPrimary: '#243DD4',
      pageBackground: 'transparent',
    },
    estimationPresets: {
      ...defaultConfig.estimationPresets,
      industryId: 'Yachting / Boating',
    },
  },
  BES_AU_RETAIL_GLOBAL: {
    ...defaultConfig,
    styles: {
      ...defaultConfig.styles,
      colorPrimary: '#9200FF',
      pageBackground: 'transparent',
    },
    estimationPresets: {
      ...defaultConfig.estimationPresets,
      industryId: 'E-Commerce',
      country: 'AU',
      region: 'NSW',
    },
  },
  TON_OF_FUN_AU: {
    ...defaultConfig,
    styles: {
      ...defaultConfig.styles,
      colorPrimary: '#9DCC49',
      pageBackground: 'transparent',
    },
    estimationPresets: {
      ...defaultConfig.estimationPresets,
      industryId: 'IT services',
      country: 'AU',
      region: 'NSW',
    },
  },
  BES_NZ_FORTIS: {
    ...defaultConfig,
    styles: {
      ...defaultConfig.styles,
      colorPrimary: '#019CDE',
      pageBackground: 'transparent',
    },
    estimationPresets: {
      ...defaultConfig.estimationPresets,
      country: 'NZ',
    },
  },
};
